<app-main [type]="'400'"></app-main>
